/* eslint-disable jsx-a11y/no-distracting-elements */
// @ts-nocheck

import * as React from "react"
import { useResizeObserver } from "../../../hooks/useResizeObserver"
import { Text, Button } from "@chakra-ui/react"
import { MarqueeButtonProps } from "./buttons.interface"
import { useTranslation } from "react-i18next"

export const MarqueeButton: React.FC<MarqueeButtonProps> = props => {
  const { t } = useTranslation()
  const { textButton, customStyles, ...otherProps } = props
  const buttonRef = React.useRef<HTMLButtonElement>(null)
  const textRef = React.useRef<HTMLParagraphElement>(null)

  const [widthButton] = useResizeObserver(buttonRef)
  const [widthText] = useResizeObserver(textRef)

  const isBigText = React.useMemo<boolean>(
    () =>{
      if(!widthText) return false
      return widthButton < (widthText + 8) // added 8 to avoid text for touching the border
    },
    [widthButton, widthText]
  )

  return (
    <Button
      {...otherProps}
      ref={buttonRef}
      display="inline-flex"
      position="relative"
      height="2rem"
      paddingLeft="0px"
      paddingRight="0px"
      minWidth="70px"
      appearance="none"
      alignItems="center"
      borderStyle="solid"
      whiteSpace="nowrap"
      verticalAlign="middle"
      outline="transparent solid 2px"
      outlineOffset="2px"
      width="auto"
      borderWidth="1px"
      borderRadius="0.375rem"
      fontWeight="600"
      fontSize="0.875rem"
      lineHeight="1.2"
      style={{ ...customStyles?.button }}
      _focus={{}}
      _active={{}}
      _hover={customStyles?.button?._hoverStyles}
    >
      {isBigText ? (
        <marquee
          style={{ maxWidth: "100px", ...customStyles?.textButton }}
          truespeed="200"
          scrolldelay="200"
        >
          {t(textButton)}
        </marquee>
      ) : (
        <Text maxW="100px" style={{ ...customStyles?.textButton }}>
          {t(textButton)}
        </Text>
      )}

      <Text ref={textRef} visibility="hidden" pos="absolute">
        {t(textButton)}
      </Text>
    </Button>
  )
}
